import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import axios from '@/utils/request';
import store from '@/store';

const DefaultLayout = () => import(/* webpackChunkName: "default-layout" */ '@/layout/default-layout.vue')
const SimpleLayout = () => import(/* webpackChunkName: "full-screen-layout" */ '@/layout/full-screen-layout.vue')
const Home = () => import(/* webpackChunkName: "home" */ '@/views/home/index.vue')



Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/main',
    component: DefaultLayout,
    meta: {},
    redirect: '/main/index',
    children: [
      { path: 'index', component: Home }
    ]
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { code: 'PER0000009', isRouterAuth: false, title: '首页' },
    redirect: '/main/index'
  },
  {
    path: '/404',
    name: '404',
    meta: { code: '404', isRouterAuth: false, title: '404' },
    component: () => import(/* webpackChunkName: "404" */ '@/views/error/404/404.vue')
  },
  {
    path: '/403',
    name: '403',
    meta: { code: '403', isRouterAuth: false, title: '403' },
    component: () => import(/* webpackChunkName: "403" */ '@/views/error/403/403.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { code: 'login', isRouterAuth: false, title: '登录' },
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/login.vue')
  },
  {
    path: '/accessFail',
    name: '401',
    meta: { code: '401', isRouterAuth: false, title: '401' },
    component: () => import(/* webpackChunkName: "401" */ '@/views/error/401/401.vue')
  },
  {//通知公告详情
    path: '/detailed',
    name: 'detailed',
    meta: { code: 'notice_deteils', isRouterAuth: false, title: '通知公告' },
    component: () => import(/* webpackChunkName: "notice_deteils" */ '@/views/notice/notice_deteils.vue')
  },
  {//通知公告列表
    path: '/list',
    name: 'list',
    meta: { code: 'notice_index', isRouterAuth: false, title: '通知公告' },
    component: () => import(/* webpackChunkName: "notice_index" */ '@/views/notice/notice_index.vue')
  },
  {
    path: '/goods',
    component: DefaultLayout,
    redirect: '/main/index',
    meta: {},
    children: [
      { path: 'index', component: Home },
      {
        path: 'goodsManage',
        component: SimpleLayout,
        children: [
          {
            path: 'goodsManage',
            name: 'goodsManage',
            component: () => import(/* webpackChunkName: "goodsManage" */ '@/views/goods/goodsManage/goodsManage.vue'),
            meta: { code: 'PER0000011', isRouterAuth: true, title: '商品管理', permissions: [] }
          }
        ]
      },
      {
        path: 'goodsAddition',
        component: SimpleLayout,
        children: [
          {
            path: 'goodsAddition',
            name: 'goodsAddition',
            component: () => import(/* webpackChunkName: "goodsAddition" */ '@/views/goods/goodsAddition/goodsAddition.vue'),
            meta: { code: 'PER0000012', isRouterAuth: true, title: '商品新增', permissions: [] }
          }
        ]
      },
      {
        path: 'goodsImport',
        component: SimpleLayout,
        children: [
          {
            path: 'goodsImport',
            name: 'goodsImport',
            component: () => import(/* webpackChunkName: "goodsImport" */ '@/views/goods/goodsImport/goodsImport.vue'),
            meta: { code: 'PER0000013', isRouterAuth: true, title: '商品导入', permissions: [] }
          }
        ]
      },
      {
        path: 'brand',
        component: SimpleLayout,
        children: [
          {
            path: 'brand',
            name: 'brand',
            component: () => import(/* webpackChunkName: "brand_view" */ '@/views/supplier/brand/brand_view.vue'),
            meta: { code: 'PER0000014', isRouterAuth: true, title: '品牌管理', permissions: [] }
          },
        ]
      },
      {//商品编辑  从 商品管理页面编辑功能跳转过来
        path: 'goodsEdit',
        component: SimpleLayout,
        children: [
          {
            path: 'goodsEdit',
            name: 'goodsEdit',
            component: () => import(/* webpackChunkName: "goodsAddition" */ '@/views/goods/goodsAddition/goodsAddition.vue'),
            meta: {
              code: 'PER0000011',
              isRouterAuth: true,
              title: '商品编辑',
              parentPath: '/goods/goodsManage/goodsManage',
              permissions: []
            }
          }
        ]
      },
      {
        path: 'batchOperation',
        component: SimpleLayout,
        children: [
          {
            path: 'batchOperation',
            name:'batchOperation',
            component: () => import(/* webpackChunkName: "batchOperation" */ '@/views/goods/batchOperation/batchOperation.vue'),
            meta: { code:'PER0000073',isRouterAuth: true, title: '批量操作',  permissions: [] }
          }
        ]
      }
    ]
  },
  {
    path: '/order',
    component: DefaultLayout,
    redirect: '/main/index',
    meta: {},
    children: [
      { path: 'index', component: Home },
      {
        path: 'orderInfo',
        component: SimpleLayout,
        children: [
          {//订单管理列表
            path: 'list',
            component: () => import(/* webpackChunkName: "order_list_view" */ '@/views/order/order_list_view.vue'),
            meta: { code: 'PER0000016', isRouterAuth: true, title: '订单列表', permissions: [] }
          },
          {//订单管理详情
            path: 'detailed',
            component: () => import(/* webpackChunkName: "order_detailed_view" */ '@/views/order/order_detailed_view.vue'),
            meta: {
              code: 'PER0000016',
              isRouterAuth: true,
              title: '订单详情',
              parentPath: '/order/orderInfo/list',
              permissions: []
            }
          },
          {
            path: 'processing',
            name: 'processing',
            component: () => import(/* webpackChunkName: "order_processing" */ '@/views/order/order_processing.vue'),
            meta: { code: 'PER0000017', isRouterAuth: true, title: '订单处理', permissions: [] }
          },
          {//售后管理
            path: 'afterSale_list',
            name: 'afterSale_list',
            component: () => import(/* webpackChunkName: "afterSale_list" */ '@/views/order/afterSale/afterSale_list.vue'),
            meta: { code: 'PER0000018', isRouterAuth: true, title: '售后单列表', permissions: [] }
          },
          {//售后管理详情
            path: 'afterSale_detail',
            name: 'afterSale_detail',
            component: () => import(/* webpackChunkName: "afterSale_detail" */ '@/views/order/afterSale/afterSale_detail.vue'),
            meta: {
              code: 'PER0000018',
              isRouterAuth: true,
              title: '售后单详情',
              parentPath: '/order/orderInfo/afterSale_list',
              permissions: [],
            }
          },
          {
            path: 'wantList',
            name: 'wantList',
            component: () => import(/* webpackChunkName: "wantList" */ '@/views/order/wantList.vue'),
            meta: { code: 'PER0000020', isRouterAuth: true, title: '缺货单', permissions: [] }
          },
          {//发货单列表
            path: 'send_out',
            name: 'send_out',
            component: () => import(/* webpackChunkName: "order_send_out" */ '@/views/order/order_send_out.vue'),
            meta: { code: 'PER0000019', isRouterAuth: true, title: '发货单', permissions: [] }
          },
          {//发货单详情
            path: 'send_out_detailed',
            name: 'send_out_detailed',
            component: () => import(/* webpackChunkName: "order_send_out_detailed" */ '@/views/order/order_send_out_detailed.vue'),
            meta: { code: 'PER0000019', isRouterAuth: true, title: '发货单', permissions: [] }
          },

        ]
      }
    ]
  },
  {
    path: '/freightManagement',
    component: DefaultLayout,
    redirect: '/main/index',
    meta: {},
    children: [
      { path: 'index', component: Home },
      {
        path: 'freight',
        component: SimpleLayout,
        children: [
          {
            path: 'install',
            name: 'install',
            component: () => import(/* webpackChunkName: "freightInstall" */ '@/views/freight/freightInstall/freightInstall.vue'),
            meta: { code: 'PER0000022', isRouterAuth: true, title: '运费模式设置', permissions: [] }
          },
          {
            path: 'order',
            name: 'order',
            component: () => import(/* webpackChunkName: "freightOrder" */ '@/views/freight/freightOrder/freightOrder.vue'),
            meta: { code: 'PER0000023', isRouterAuth: true, title: '订单运费模板', permissions: [] }
          },
          {
            path: 'product',
            name: 'product',
            component: () => import(/* webpackChunkName: "freightProduct" */ '@/views/freight/freightProduct/freightProduct.vue'),
            meta: { code: 'PER0000024', isRouterAuth: true, title: '单品运费模板', permissions: [] }
          }
        ]
      }
    ]
  },
  {
    path: '/maintain',
    component: DefaultLayout,
    meta: {},
    redirect: '/main/index',
    children: [
      { path: 'index', component: Home },
      {
        path: 'administer',
        component: SimpleLayout,
        children: [
          {
            path: 'user',
            name: 'user',
            component: () => import(/* webpackChunkName: "userManageView" */ '@/views/maintain/userManageView/index.vue'),
            meta: { code: 'PER0000026', isRouterAuth: true, title: '用户管理', permissions: [] }
          },
          {
            path: 'addressManagement',
            name: 'addressManagement',
            component: () => import(/* webpackChunkName: "addressManagement" */ '@/views/maintain/addressManagement.vue'),
            meta: { code: 'PER0000027', isRouterAuth: true, title: '地址管理', permissions: [] }
          },
          {
            path: 'management',
            name: 'management',
            component: () => import(/* webpackChunkName: "management" */ '@/views/management/index.vue'),
            meta: { code: 'PER0000028', isRouterAuth: true, title: '商家管理', permissions: [] }
          }
        ]
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

/*
 *@description:'获取 拉平的 权限list'
*/
const getPermissionFlattenList = () => {
  return JSON.parse(localStorage.getItem('permissionFlattenList'))
}

/*
 *@description:'已经注册的路由'
*/
// const allRegisteredRoutesList = router.getRoutes()

router.beforeEach(async (to, from, next) => {
  const { meta, path } = to
  const isRouterAuth = meta.isRouterAuth ?? true //兼容一下 随便输入的 路径 没有 isRouterAuth属性
  const token = localStorage.getItem('authToken')

  if (token) {
    getBusinessModel()
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    if (to.path === '/login') {
      next('/')
      return
    }
    if (path === '/main/index' || !isRouterAuth) {
      // 任何情况都可以跳转的路由  isRouterAuth:true
      next()
    } else {
      const permissionFlattenList = getPermissionFlattenList()
      const flag = permissionFlattenList.some(item => {
        return item?.menuPath === to.path || item?.menuPath === to.meta.parentPath
      })
      if (flag) {
        next()
      } else {
        next({ path: '/', replace: true })
      }
    }
  } else {
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  }
})
const getBusinessModel = async () => {
  const { businessModel } = store.state
  if(!businessModel){
      store.dispatch('BUSINESS_MODEL');
  }
}
export default router;
